import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_NOTICE = defineFcm('homepage_notice')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				desktop_prefix: { type: 'string' },
				desktop_copy: { type: 'string' },
				desktop_link_text: { type: 'string' },
				mobile_prefix: { type: 'string' },
				mobile_copy: { type: 'string' },
				mobile_link_text: { type: 'string' },
				url: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'TBD',
		scope: 'TBD',
		context: 'Homepage',
		description: `Used to display a notice on the homepage.
		The "xxx_prefix" is some bold uppercase text displayed before the copy.
		The "url" and "xxx_link_text" are used to generate a link.`,
		template: {
			desktop_prefix: 'TODO',
			desktop_copy: 'TODO',
			desktop_link_text: 'TODO',
			mobile_prefix: 'TODO',
			mobile_copy: 'TODO',
			mobile_link_text: 'TODO',
			url: 'https://www.change.org',
		},
		deprecated: 'No references found. Safe to delete after 2026-11-09.',
	});
